//# sourceMappingURL=my-date-range.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-mydatepicker/dist/interfaces/my-date-range.interface.js
// module id = 566
// module chunks = 10